import { Outlet } from "react-router-dom";
import useShopPage from "@/viewModels/shop/useShopPage";
import { stripHTML } from "@/utils/utils";
import PageBanner from "@/pages/shop/components/PageBanner";
import ProductCategories from "@/pages/shop/components/ProductCategories";
import RoastAttrTermsComponent from "@/pages/shop/components/RoastAttrTerms";
import ProductSortSelector from "@/pages/shop/components/ProductSortSelector";
import SEOMeta from "@/components/ui/meta/SEOMeta";

const ShopPage = () => {
  const {
    products,
    hasMoreProducts,
    isLoadingProducts,
    selectedSortOption,
    fetchMoreProducts,
    updateSelectedSortOption,

    categories,
    currentCategory,
    isLoadingCategories,
    checkIsActiveCategory,

    roastAttrTerms,
    selectedRoastTerm,
    isLoadingRoastAttr,
    updateSelectedRoastAttrTerm,
  } = useShopPage();

  return (
    <>
      <PageBanner category={currentCategory} isLoading={isLoadingCategories} />
      <div className="brand-container flex flex-col gap-4 py-8 lg:flex-row lg:gap-10">
        {/* Sidebar: filter, category */}
        <aside className="w-full lg:w-1/4">
          <ProductCategories
            categories={categories}
            currentCategory={currentCategory}
            isLoading={isLoadingCategories}
            checkIsActiveCategory={checkIsActiveCategory}
          />
        </aside>
        {/* Main */}
        <div className="flex w-full flex-col lg:w-3/4">
          <div className="mb-4 flex justify-between lg:items-end">
            {/* Breadcrumb */}
            {/* Filter: Roast Attr Terms */}
            <RoastAttrTermsComponent
              terms={roastAttrTerms}
              selectedTerm={selectedRoastTerm}
              isLoading={isLoadingRoastAttr}
              onSelect={updateSelectedRoastAttrTerm}
            />
            {/* Order By */}
            <ProductSortSelector
              orderBy={selectedSortOption}
              onOrderChange={updateSelectedSortOption}
            />
          </div>
          {/* Product List */}
          <Outlet
            context={{
              products,
              isLoadingProducts,
              hasMoreProducts,
              fetchMoreProducts,
            }}
          />
        </div>
      </div>
      {/* Meta Tag */}
      <SEOMeta
        pageTitle={currentCategory?.name || "所有商品"}
        description={stripHTML(currentCategory?.description || "") || ""}
      />
    </>
  );
};

export default ShopPage;
